import { NgModule } from '@angular/core';
import { TicketsTestsPageComponent } from './view/tickets-tests-page/tickets-tests-page.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { MiscModule } from 'projects/core/src/public-api';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CustomerMiscModule } from '../modules/customer/customer-misc.module';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DesktopProjectModule } from 'projects/desktop/src/app/modules/project/desktop-project.module';


@NgModule({
    declarations: [
        TicketsTestsPageComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        MatDialogModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        AccordionModule,
        SelectButtonModule,
        CalendarModule,
        MiscModule,
        OverlayPanelModule,
        CustomerMiscModule,
        CheckboxModule,
        DropdownModule,
        ConfirmDialogModule,
        InputSwitchModule,
        DesktopProjectModule
    ],
    entryComponents: []
})
export class TestsPageModule { }
